import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/do';
import { MessageService } from './message.service';
// import { timeout } from 'rxjs/operators';
import 'rxjs-compat/add/operator/timeout';
import { E } from '@angular/cdk/keycodes';

@Injectable({
    providedIn: 'root'
})

export class InterceptorService implements HttpInterceptor {

    constructor(private messageService: MessageService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.messageService.getToken();
        const id = this.messageService.getUserId();
        const getclientId = this.messageService.getclientId();
        const re = '/login';
        const client = '/getLoginClientList';
        const loginlt = '/loginlt';
        const updateFile = '/updateFile';
        const tokenGenerate = '/generateToken';
        const tokenValiadation = '/tokenValidation';
        const getIp = 'http://api.ipify.org/';
        const getPsInfo = 'https://sscinternalapps.larsentoubro.com/employeedata/employeecontact.asmx';
        // if( !token)
        console.log('request.url == >>> ' + request.url);
        const url = new URL(request.url);
        const search_params = url.searchParams;
        console.log('search_params===  >>> ' + search_params);
        const getLoginClientList = '/getLoginClientList';

        // console.log(new URL(request.url).searchParams.get('userId'));

        let ccid = Number(this.messageService.getclientId());

        const ccCode = String(this.messageService.getclientCode());

        console.log('ccCode == >> ' + ccCode + ', ccid == >>> ' + ccid + ' - loginlt --  ' + request.url.search(loginlt));

        if (request.url.search(updateFile) === -1 && request.url.search(re) === -1 && request.url.search(client) === -1 &&
            request.url.search(loginlt) === -1 && request.url.search(tokenGenerate) === -1 && request.url.search(tokenValiadation) === -1
            && request.url.search(getIp) === -1 && request.url.search(getPsInfo) === -1 && request.url.search(getLoginClientList) === -1) {
            // let userId;
            let newParams = new HttpParams({ fromString: request.params.toString() });

            if (request.method === 'GET') { 

                const user_id = this.messageService.getQueryStringValue('user_id', request.url);

                if (user_id === null || user_id === '' || user_id === undefined) {
                    newParams = newParams.append('user_id', id);
                }

                // if (getclientId !== undefined || getclientId !== null) {
                //     const mapping_client_config_id = this.messageService.getQueryStringValue('mapping_client_config_id', request.url);
                //     if (mapping_client_config_id === null || mapping_client_config_id === '' || mapping_client_config_id === undefined) {
                //         newParams = newParams.append('mapping_client_config_id', getclientId);
                //     }
                // }
            }
            if (request.method === 'POST') {
                console.log('post.......')
                if (!request.body.user_id) {
                    request.body.user_id = id;
                    if (request.body.userId) {
                        delete request.body.userId;
                    }
                }

                // if (getclientId !== undefined || getclientId !== null) {
                //     if (!request.body.mapping_client_config_id) {
                //         request.body.mapping_client_config_id = getclientId;
                //     }
                // } 

            }
            request = request.clone({
                setHeaders: {
                    Authorization: token
                    // Auth: id
                },
                params: newParams
            });
        }
        //  else {
        //     if (request.method === 'GET') {

        //         let newParams = new HttpParams({ fromString: request.params.toString() });

        //         const client_id = this.messageService.getQueryStringValue('clientId', request.url);

        //         console.log('INDISE -1 client_id == >>> ' + client_id + ', ccCode == ' + ccCode)

        //         if (client_id === undefined || client_id === null || client_id === '') {

        //             console.log('INDISE -1 IF ccCode == >>> ' + ccCode + ', ccid == >>> ' + ccid);

        //             if (ccid == undefined || ccid == null || ccid == 0) {
        //                 if (ccCode == undefined || ccCode == null || ccCode == '') {
        //                     alert(this.messageService.URL_TOKEN_ERROR);
        //                     this.messageService.logOut();
        //                 } else {
        //                     newParams = newParams.append('mapping_client_code_config', String(ccCode));
        //                 }
        //             } else {
        //                 newParams = newParams.append('mapping_client_config_id', String(ccid));

        //             }
        //         } else {
        //             console.log('INDISE -1 ELSE client_id == >>> ' + client_id + ', newParams == >>> ' + request.params.toString());
        //             this.messageService.setClientId(client_id);
        //             newParams = newParams.append('mapping_client_config_id', client_id);
        //         }
        //         request = request.clone({
        //             params: newParams
        //         });
        //     } else {
        //         if (request.method === 'POST') {

        //             if (request.body.clientId) {
        //                 ccid = Number(request.body.clientId);
        //             }

        //             if (ccid === undefined || ccid == null || ccid === 0) {
        //                 if (ccCode == undefined || ccCode == null || ccCode == '') {
        //                     alert(this.messageService.URL_TOKEN_ERROR);
        //                     this.messageService.logOut();
        //                 } else {
        //                     request.body.mapping_client_code_config = String(ccCode);
        //                 }
        //             } else {
        //                 request.body.mapping_client_config_id = ccid;
        //             }
        //         }
        //     }
        // }
        return next.handle(request).do((event: HttpEvent<any>) => {
            // console.log(event);
            if (event instanceof HttpResponse) {
                // do stuff with response if you want
                // console.log(event.headers);
                const jwt = event.headers.get('Autho');
                if (jwt !== null) {
                    sessionStorage.setItem('data', jwt);
                }
            }
        }, (err: any) => {
            if (err instanceof HttpErrorResponse) {
                console.log(err);
                if (err.status === 400) {
                    alert(this.messageService.URL_TOKEN_ERROR);
                    this.messageService.logOut();
                }
            }
        });
    }
}
